import axios from "axios"

if (process.env.NODE_ENV !== "production") {
  axios.defaults.baseURL = "http://localhost:3030"
}

// MARK: State
const state = () => ({
  burgstrasse: {
    info: {},
    data: {
      time: {
        time: "",
      },
      departures: [],
    },
  },
  hammerbrook: {
    info: {},
    data: {
      time: {
        time: "",
      },
      departures: [],
    },
  },
  s_hammerbrook: {
    info: {},
    data: {
      time: {
        time: "",
      },
      departures: [],
    },
  },
  berliner_tor: {
    info: {},
    data: {
      time: {
        time: "",
      },
      departures: [],
    },
  },
  landwehr: {
    info: {},
    data: {
      time: {
        time: "",
      },
      departures: [],
    },
  },
})

// MARK: Getters
const getters = {
  stationBurgstrasseData(state) {
    return state.burgstrasse
  },
  stationHammerbrookData(state) {
    return state.hammerbrook
  },
  stationSHammerbrookData(state) {
    return state.s_hammerbrook
  },
  stationBerlinerTorData(state) {
    return state.berliner_tor
  },
  stationLandwehrData(state) {
    return state.landwehr
  },
}

// MARK: Actions
const actions = {
  async getBurgstrasse({ commit }) {
    const response = await axios
      .get("/api/hvvstations/burgstrasse", {
        withCredentials: false,
        credentials: "include",
        headers: {
          "x-access-token": localStorage.getItem("access_token"),
        },
      })
      .catch((err) => {
        console.log("err:", err)
      })

    if (response && response.data) {
      commit("setBurgstrasse", response.data)
    }
  },
  async getHammerbrook({ commit }) {
    const response = await axios
      .get("/api/hvvstations/hammerbrook", {
        withCredentials: false,
        credentials: "include",
        headers: {
          "x-access-token": localStorage.getItem("access_token"),
        },
      })
      .catch((err) => {
        console.log("err:", err)
      })

    if (response && response.data) {
      commit("setHammerbrook", response.data)
    }
  },
  async getSHammerbrook({ commit }) {
    const response = await axios
      .get("/api/hvvstations/s_hammerbrook", {
        withCredentials: false,
        credentials: "include",
        headers: {
          "x-access-token": localStorage.getItem("access_token"),
        },
      })
      .catch((err) => {
        console.log("err:", err)
      })

    if (response && response.data) {
      commit("setSHammerbrook", response.data)
    }
  },
  async getBerlinerTor({ commit }) {
    const response = await axios
      .get("/api/hvvstations/berliner_tor", {
        withCredentials: false,
        credentials: "include",
        headers: {
          "x-access-token": localStorage.getItem("access_token"),
        },
      })
      .catch((err) => {
        console.log("err:", err)
      })

    if (response && response.data) {
      commit("setBerlinerTor", response.data)
    }
  },
  async getLandwehr({ commit }) {
    const response = await axios
      .get("/api/hvvstations/landwehr", {
        withCredentials: false,
        credentials: "include",
        headers: {
          "x-access-token": localStorage.getItem("access_token"),
        },
      })
      .catch((err) => {
        console.log("err:", err)
      })

    if (response && response.data) {
      commit("setLandwehr", response.data)
    }
  },
}

// MARK: Mutations
const mutations = {
  setBurgstrasse(state, data) {
    state.burgstrasse = data
  },
  setHammerbrook(state, data) {
    state.hammerbrook = data
  },
  setSHammerbrook(state, data) {
    state.s_hammerbrook = data
  },
  setBerlinerTor(state, data) {
    state.berliner_tor = data
  },
  setLandwehr(state, data) {
    state.landwehr = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
